/* Pots de Fleurs & Co : suppléments des variantes (remplace l'app YMQ).
   Fiche : snippets/supplements-variante.liquid. Panier : snippets/supplements-ligne.liquid.
   Chargé après theme.js (layout/theme.liquid). */
(() => {
  if (!window.theme?.pubsub) return;

  const formatMoney = (cents) => theme.Currency.formatMoney(cents, theme.settings.currencyCodeEnabled ? theme.settings.moneyWithCurrencyFormat : theme.settings.moneyFormat);

  /* 1. Fiche produit
     ------------------------------------------------------------ */

  // Choix du client par formulaire et par supplément (nom du produit supplément) : le bloc est
  // redessiné à chaque variante, et le supplément d'une autre taille est une autre variante.
  // Case : true / false. Liste : titre de la variante choisie.
  const memo = {};

  const choixDe = (supplement) => {
    const champ = supplement.querySelector('[data-supplement-choix]');
    if (!champ) return null;
    if (champ.type === 'checkbox') return champ.checked ? champ : null;
    const option = champ.selectedOptions[0];
    return option && option.value ? option : null;
  };

  const restaurer = (bloc) => {
    const formId = bloc.dataset.formId;
    bloc.querySelectorAll('[data-supplement]').forEach((supplement) => {
      const garde = memo[formId]?.[supplement.dataset.nom];
      if (garde === undefined) return;
      const champ = supplement.querySelector('[data-supplement-choix]');
      if (champ.type === 'checkbox') {
        champ.checked = garde === true;
      } else {
        const option = [...champ.options].find((element) => element.dataset.valeur === garde);
        champ.value = option ? option.value : '';
      }
    });
  };

  const memoriser = (supplement) => {
    const bloc = supplement.closest('[data-supplements]');
    const champ = supplement.querySelector('[data-supplement-choix]');
    const formId = bloc.dataset.formId;
    memo[formId] = memo[formId] || {};
    memo[formId][supplement.dataset.nom] = champ.type === 'checkbox' ? champ.checked : (champ.selectedOptions[0]?.dataset.valeur || '');
  };

  // Client pro : la mention « HT » (snippets/product-price.liquid) est gardée après le montant.
  // Les montants lus (data-price, data-prix) sont déjà ceux affichés, HT pour un pro.
  const prixAvecSupplement = (element, supplement) => {
    const libelle = element.querySelector('.price-ht-label');
    const texte = libelle ? element.textContent.replace(libelle.textContent, '').trim() : element.textContent;
    if (element.dataset.prixAffiche !== texte) {
      element.dataset.prixBase = texte;
      element.dataset.prixBaseCentimes = element.closest('[data-price]')?.dataset.price || '';
    }
    const base = parseInt(element.dataset.prixBaseCentimes, 10);
    const montant = Number.isNaN(base) ? montantDe(element.dataset.prixBase) : base;
    if (montant === null) return;
    element.textContent = supplement ? formatMoney(montant + supplement) : element.dataset.prixBase;
    element.dataset.prixAffiche = element.textContent;
    if (libelle) element.append(' ', libelle);
  };

  const montantDe = (texte) => {
    const trouve = (texte || '').match(/\d[\d.\s  ]*,\d{2}/);
    return trouve ? Math.round(parseFloat(trouve[0].replace(/[.\s  ]/g, '').replace(',', '.')) * 100) : null;
  };

  const synchroniser = (bloc) => {
    const formId = bloc.dataset.formId;
    let total = 0;
    let skuComplet = '';
    const articles = [];
    bloc.querySelectorAll('[data-supplement]').forEach((supplement) => {
      const choisi = choixDe(supplement);
      const id = choisi ? choisi.value : '';
      const article = supplement.querySelector('[data-supplement-article]');
      article.value = id;
      article.checked = !!id;
      const propriete = supplement.querySelector('[data-supplement-propriete]');
      propriete.value = choisi ? choisi.dataset.valeur : '';
      propriete.disabled = !id;
      const lien = supplement.querySelector('[data-supplement-lien]');
      if (lien) {
        lien.value = id;
        lien.disabled = !id;
      }
      if (!choisi) return;
      const prix = parseInt(choisi.dataset.prix, 10) || 0;
      total += prix;
      articles.push({ price: prix, quantity: 1 });
      if (choisi.dataset.skuComplet) skuComplet = choisi.dataset.skuComplet;
    });

    const champSku = bloc.querySelector('[data-supplement-sku]');
    if (champSku) {
      champSku.value = skuComplet;
      champSku.disabled = !skuComplet;
    }

    const cle = formId.replace(/^ProductForm-/, '');
    document.querySelectorAll(`#Price-${CSS.escape(cle)} .price__regular, #StickyPrice-${CSS.escape(cle)} .price__regular`)
      .forEach((element) => prixAvecSupplement(element, total));
    // Prix du bouton d'ajout : product-buy-price écoute bundle:change sur le formulaire.
    if (!bloc.querySelector('[data-supplement]')) return;
    const formulaire = document.forms[formId];
    (formulaire ?? document).dispatchEvent(new CustomEvent('bundle:change', { detail: { items: articles } }));
  };

  const toutSynchroniser = () => document.querySelectorAll('[data-supplements]').forEach(synchroniser);

  document.addEventListener('change', (event) => {
    const supplement = event.target.closest?.('[data-supplement]');
    if (!supplement || !event.target.matches('[data-supplement-choix]')) return;
    const erreurChoix = supplement.querySelector('[data-supplement-erreur]');
    if (erreurChoix) erreurChoix.hidden = true;
    memoriser(supplement);
    synchroniser(supplement.closest('[data-supplements]'));
  });

  // Variante changée : le thème a redessiné la fiche, le bloc des suppléments est repris de la
  // réponse (ses suppléments dépendent de la taille et de la référence), puis le choix restauré.
  theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.variantChange, (event) => {
    const { sectionId, productId, parsedHTML } = event?.data || {};
    const id = `Supplements-${sectionId}-${productId}`;
    const source = parsedHTML?.getElementById(id);
    const bloc = document.getElementById(id);
    if (source && bloc) {
      bloc.innerHTML = source.innerHTML;
      bloc.hidden = source.hidden;
      restaurer(bloc);
    }
    // Le thème réécrit les prix juste après : on repasse derrière lui.
    toutSynchroniser();
    setTimeout(toutSynchroniser, 50);
    setTimeout(toutSynchroniser, 600);
  });
  document.addEventListener('quickview:loaded', toutSynchroniser);
  toutSynchroniser();

  // Option de produit obligatoire (ancrage d'une serre) : pas d'ajout au panier sans choix.
  document.addEventListener('submit', (event) => {
    const formId = event.target.getAttribute?.('id');
    if (!formId) return;
    for (const bloc of document.querySelectorAll(`[data-supplements][data-form-id="${CSS.escape(formId)}"]`)) {
      if (bloc.hidden) continue;
      const manquant = [...bloc.querySelectorAll('select[data-obligatoire]')].find((champ) => !champ.value);
      if (!manquant) continue;
      event.preventDefault();
      event.stopImmediatePropagation();
      const supplement = manquant.closest('[data-supplement]');
      const erreur = supplement.querySelector('[data-supplement-erreur]');
      erreur.textContent = (window.theme?.supplementRequis || '').replace('[supplement]', supplement.dataset.nom);
      erreur.hidden = false;
      supplement.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
  }, true);

  // Info-bulle d'un supplément : le « i » l'ouvre ou la ferme (toucher), la croix, Échap ou un
  // clic ailleurs la ferment. Au survol, le CSS l'ouvre seul. La pointe se cale sur le « i ».
  const fermerBulles = (sauf) => document.querySelectorAll('[data-info-bulle][aria-expanded="true"]')
    .forEach((bouton) => { if (bouton !== sauf) bouton.setAttribute('aria-expanded', 'false'); });
  const caler = (bouton) => {
    const cadre = bouton.nextElementSibling;
    if (cadre) cadre.style.setProperty('--fleche', `${bouton.offsetLeft + 11}px`);
  };
  document.addEventListener('mouseover', (event) => {
    const bulle = event.target.closest?.('.info-bulle');
    const bouton = bulle?.querySelector('[data-info-bulle]');
    if (bouton) caler(bouton);
  });
  document.addEventListener('click', (event) => {
    const bouton = event.target.closest('[data-info-bulle]');
    if (bouton) {
      caler(bouton);
      const ouvert = bouton.getAttribute('aria-expanded') === 'true';
      fermerBulles(bouton);
      bouton.setAttribute('aria-expanded', ouvert ? 'false' : 'true');
      return;
    }
    if (event.target.closest('[data-info-bulle-fermer]') || !event.target.closest('.info-bulle__cadre')) fermerBulles();
  });
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') fermerBulles(); });

  // Les suppléments partent au panier avec la quantité du produit (le thème les met à 1).
  const ProductForm = customElements.get('product-form');
  if (ProductForm) {
    const original = ProductForm.prototype.prepareFormData;
    ProductForm.prototype.prepareFormData = function (formData) {
      const donnees = original.call(this, formData);
      const quantite = parseInt(formData.get('quantity'), 10) || 1;
      const ids = new Set([...document.querySelectorAll(`[data-supplements][data-form-id="${this.id}"] [data-supplement-article]:checked`)].map((article) => String(article.value)));
      donnees.items.forEach((item, index) => {
        if (index < donnees.items.length - 1 && ids.has(String(item.id))) item.quantity = quantite;
      });
      return donnees;
    };
  }

  /* 2. Panier
     ------------------------------------------------------------ */

  // La quantité de chaque supplément suit celle des lignes qui le réclament (propriétés
  // « _Supplément <nom> ») : produit retiré ou quantité changée, le supplément suit.
  const SOURCE_SUPPLEMENTS = 'pdf-supplements';
  let synchroEnCours = false;

  // Compteurs (en-tête) : sans les suppléments réclamés, fondus dans la ligne de leur produit.
  // Même calcul que snippets/nombre-articles-panier.liquid.
  const nombreArticles = (cart) => {
    if (!Array.isArray(cart?.items)) return cart?.item_count;
    const reclames = new Set();
    cart.items.forEach((item) => Object.entries(item.properties || {}).forEach(([cle, valeur]) => {
      if (cle.startsWith('_Supplément') && valeur) reclames.add(String(valeur));
    }));
    return cart.items.reduce((total, item) => (
      item.product_type === 'Supplément' && reclames.has(String(item.variant_id)) ? total : total + item.quantity
    ), 0);
  };

  const majCompteurs = (cart) => {
    const nombre = nombreArticles(cart);
    if (typeof nombre !== 'number') return;
    document.querySelectorAll('cart-count').forEach((compteur) => {
      compteur.innerText = nombre;
      compteur.hidden = nombre === 0;
    });
  };

  const panierComplet = async () => (await fetch(`${theme.routes.cart_url}.js`, theme.utils.fetchConfig('json', 'GET'))).json();

  const synchroniserPanier = async (cart) => {
    if (synchroEnCours || !cart?.items) return;
    const besoin = {};
    const presents = {};
    cart.items.forEach((item) => {
      Object.entries(item.properties || {}).forEach(([cle, supplement]) => {
        if (!cle.startsWith('_Supplément') || !supplement) return;
        besoin[supplement] = (besoin[supplement] || 0) + item.quantity;
      });
      if (item.product_type === 'Supplément') presents[item.variant_id] = (presents[item.variant_id] || 0) + item.quantity;
    });

    const updates = {};
    Object.entries(presents).forEach(([variante, quantite]) => {
      if (quantite !== (besoin[variante] || 0)) updates[variante] = besoin[variante] || 0;
    });
    const ajouts = Object.entries(besoin).filter(([variante]) => !presents[variante]).map(([id, quantity]) => ({ id: parseInt(id, 10), quantity }));
    if (!Object.keys(updates).length && !ajouts.length) {
      majCompteurs(cart);
      return;
    }

    synchroEnCours = true;
    try {
      const config = theme.utils.fetchConfig('json');
      const reponses = [];
      if (Object.keys(updates).length) reponses.push(await fetch(`${theme.routes.cart_update_url}.js`, { ...config, body: JSON.stringify({ updates }) }));
      if (ajouts.length) reponses.push(await fetch(`${theme.routes.cart_add_url}.js`, { ...config, body: JSON.stringify({ items: ajouts }) }));
      // Supplément refusé (produit retiré de la vente) : pas de rechargement, qui bouclerait.
      if (reponses.some((reponse) => !reponse.ok)) return;
      if (document.body.classList.contains('template-cart')) {
        window.location.reload();
        return;
      }
      const nouveauPanier = await panierComplet();
      theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: SOURCE_SUPPLEMENTS, cart: nouveauPanier });
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: false } }));
      majCompteurs(nouveauPanier);
    } finally {
      synchroEnCours = false;
    }
  };

  theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, async (event) => {
    if (event?.cart?.errors || event?.source === SOURCE_SUPPLEMENTS) return;
    // L'ajout depuis la fiche ne renvoie que les articles ajoutés : panier relu en entier.
    const cart = Array.isArray(event?.cart?.items) && typeof event.cart.item_count === 'number' ? event.cart : await panierComplet();
    synchroniserPanier(cart);
  });
  if (document.body.classList.contains('template-cart')) panierComplet().then(synchroniserPanier);
})();

/* Aperçu agrandi des pastilles de couleur (repris de Verano Design) : au survol sur ordinateur,
   après un court délai ; à l'appui sur mobile. Pastilles marquées data-apercu dans
   snippets/product-variant-picker-swatch.liquid et snippets/nuancier-groupe.liquid, styles dans snippets/style-options-ymq.liquid. */
(() => {
  const PASTILLE = '.color-swatch[data-apercu], [data-nuancier-pastille][data-apercu]';
  const DELAI = 180;
  const survolFin = window.matchMedia('(hover: hover) and (pointer: fine)');
  const charges = new Set();
  let boite = null;
  let minuterie = null;

  const charger = (url) => {
    if (!url || charges.has(url)) return;
    charges.add(url);
    new Image().src = url;
  };

  const boiteApercu = () => {
    if (boite) return boite;
    boite = document.createElement('div');
    boite.className = 'pastille-apercu';
    boite.setAttribute('aria-hidden', 'true');
    boite.innerHTML = '<img class="pastille-apercu__image" width="480" height="480" alt=""><span class="pastille-apercu__nom"></span>';
    document.body.appendChild(boite);
    return boite;
  };

  const cacher = () => boite?.classList.remove('is-visible');

  const annuler = () => {
    clearTimeout(minuterie);
    minuterie = null;
  };

  const montrer = (pastille) => {
    const encart = boiteApercu();
    const image = encart.querySelector('img');
    const grande = pastille.dataset.apercu;
    // La vignette déjà chargée occupe l'encart le temps que la grande image arrive.
    if (charges.has(grande)) {
      image.src = grande;
    } else {
      image.src = pastille.dataset.vignette || grande;
      const prochaine = new Image();
      prochaine.onload = () => {
        charges.add(grande);
        if (encart.dataset.pour === grande) image.src = grande;
      };
      prochaine.src = grande;
    }
    encart.dataset.pour = grande;
    encart.querySelector('.pastille-apercu__nom').textContent = pastille.dataset.apercuNom || '';

    const rect = pastille.getBoundingClientRect();
    const largeur = encart.offsetWidth;
    const hauteur = encart.offsetHeight || largeur + 30;
    const marge = 8;
    const centre = rect.left + rect.width / 2;
    const gauche = Math.min(Math.max(centre - largeur / 2, marge), window.innerWidth - largeur - marge);
    const dessous = rect.top - hauteur - 12 < marge;
    encart.classList.toggle('is-dessous', dessous);
    encart.style.left = `${gauche}px`;
    encart.style.top = `${dessous ? rect.bottom : rect.top}px`;
    encart.style.setProperty('--fleche', `${centre - gauche}px`);
    encart.classList.add('is-visible');
  };

  const prechargerGroupe = (pastille) => {
    pastille.closest('.swatches, .nuancier__pastilles')?.querySelectorAll(PASTILLE).forEach((autre) => charger(autre.dataset.apercu));
  };

  document.addEventListener('mouseover', (event) => {
    if (!survolFin.matches) return;
    const pastille = event.target.closest?.(PASTILLE);
    if (!pastille) return;
    annuler();
    minuterie = setTimeout(() => {
      montrer(pastille);
      prechargerGroupe(pastille);
    }, DELAI);
  });

  document.addEventListener('mouseout', (event) => {
    if (!survolFin.matches) return;
    const pastille = event.target.closest?.(PASTILLE);
    if (pastille && !pastille.contains(event.relatedTarget)) {
      annuler();
      cacher();
    }
  });

  // Mobile : l'appui choisit la couleur et ouvre l'aperçu ; un appui ailleurs le ferme.
  document.addEventListener('click', (event) => {
    if (survolFin.matches) return;
    const pastille = event.target.closest?.(PASTILLE);
    if (pastille) {
      prechargerGroupe(pastille);
      montrer(pastille);
    } else if (!event.target.closest?.('.swatches, .nuancier__pastilles')) {
      // Le clic que le libellé renvoie à son bouton radio ne doit pas refermer l'aperçu.
      cacher();
    }
  });

  window.addEventListener('scroll', () => {
    annuler();
    cacher();
  }, { passive: true });
})();

/* Nuanciers conditionnels (repris de Verano Design) : snippets/nuanciers-conditionnels.liquid.
   Le nuancier de la valeur choisie s'affiche, seuls ses champs partent dans la commande, et
   l'ajout au panier attend qu'une teinte soit choisie. */
(() => {
  const variante = (bloc) => {
    const zone = bloc.closest('quick-view, .product__info') || document;
    try {
      return JSON.parse(zone.querySelector('[data-selected-variant]')?.textContent || 'null');
    } catch (erreur) {
      return null;
    }
  };

  // SKU complet : SKU de la variante suivi des codes des teintes choisies.
  const sku = (bloc, choisie) => {
    const champ = bloc.querySelector('[data-nuanciers-sku]');
    const codes = [...bloc.querySelectorAll('[data-nuancier]:not([hidden]) [data-nuancier-code]')].map((code) => code.value).filter(Boolean);
    champ.value = choisie?.sku && codes.length ? [choisie.sku, ...codes].join('_') : '';
    champ.disabled = !champ.value;
  };

  const synchroniser = (bloc) => {
    const choisie = variante(bloc);
    if (!choisie) return;
    bloc.querySelectorAll('[data-nuancier]').forEach((groupe) => {
      const position = parseInt(groupe.dataset.optionPosition, 10);
      groupe.hidden = choisie.options?.[position - 1] !== groupe.dataset.optionValue;
      groupe.querySelectorAll('[data-nuancier-teinte], [data-nuancier-code]').forEach((champ) => {
        champ.disabled = groupe.hidden || !champ.value;
      });
    });
    bloc.querySelector('[data-nuanciers-erreur]').hidden = true;
    sku(bloc, choisie);
    // Une seule teinte possible : choisie d'office.
    bloc.querySelectorAll('[data-nuancier]:not([hidden])').forEach((groupe) => {
      const pastilles = groupe.querySelectorAll('[data-nuancier-pastille]');
      if (pastilles.length === 1 && !groupe.querySelector('[data-nuancier-teinte]').value) choisir(pastilles[0]);
    });
  };

  const choisir = (pastille) => {
    const groupe = pastille.closest('[data-nuancier]');
    const bloc = groupe.closest('[data-nuanciers]');
    groupe.querySelectorAll('[data-nuancier-pastille]').forEach((autre) => autre.setAttribute('aria-checked', autre === pastille ? 'true' : 'false'));
    const teinte = groupe.querySelector('[data-nuancier-teinte]');
    const code = groupe.querySelector('[data-nuancier-code]');
    teinte.value = pastille.dataset.teinte;
    code.value = pastille.dataset.code;
    teinte.disabled = code.disabled = groupe.hidden;
    const rappel = groupe.querySelector('[data-nuancier-choisie]');
    if (rappel) {
      rappel.textContent = pastille.dataset.teinte;
      rappel.hidden = false;
    }
    bloc.querySelector('[data-nuanciers-erreur]').hidden = true;
    sku(bloc, variante(bloc));
  };

  const tout = () => document.querySelectorAll('[data-nuanciers]').forEach(synchroniser);

  document.addEventListener('click', (event) => {
    const pastille = event.target.closest?.('[data-nuancier-pastille]');
    if (pastille) choisir(pastille);
  });

  // Pas d'ajout au panier sans teinte : le client est ramené au nuancier incomplet.
  document.addEventListener('submit', (event) => {
    const formId = event.target.getAttribute?.('id');
    if (!formId) return;
    for (const bloc of document.querySelectorAll(`[data-nuanciers][data-form-id="${CSS.escape(formId)}"]`)) {
      const manquant = [...bloc.querySelectorAll('[data-nuancier]:not([hidden])')].find((groupe) => !groupe.querySelector('[data-nuancier-teinte]').value);
      if (!manquant) continue;
      event.preventDefault();
      event.stopImmediatePropagation();
      const erreur = bloc.querySelector('[data-nuanciers-erreur]');
      erreur.textContent = (window.theme?.nuancierRequis || '').replace('[nuancier]', manquant.querySelector('.nuancier__titre span').textContent);
      erreur.hidden = false;
      manquant.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
  }, true);

  window.theme?.pubsub?.subscribe(theme.pubsub.PUB_SUB_EVENTS.variantChange, () => {
    setTimeout(tout, 50);
    setTimeout(tout, 600);
  });
  document.addEventListener('change', (event) => {
    if (!event.target.closest?.('variant-picker, .product-form__input')) return;
    setTimeout(tout, 50);
  });
  document.addEventListener('quickview:loaded', tout);
  tout();
})();
